import { render } from "./cart-additional-product.vue?vue&type=template&id=59853342&lang=pug"
import script from "./cart-additional-product.vue?vue&type=script&lang=js"
export * from "./cart-additional-product.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__